angular.module('llax.services')
    .service('AdditionalCategoryService', function($rootScope, $log, $q, DataModelResource) {

        var _this = this;
        this.memo = {};
        this.statusMap = {};
        // Waiters are per category key. A single shared list made the first
        // response resolve every in-flight hitlist cell with that one category.
        this.pendingResolvers = {};

        /**
         * Memoizes the additional category loading call (parallel calls for the same key share that key's result):
         * 1- Checks IndexedDB.
         * 2- if not found, fetches the additional category from the backend.
         */
        this.loadAdditionalCategory = function(additionalCategoryNameOrCode,
                                               additionalService,
                                               additionalModule) {

            if (_.isEmpty(additionalCategoryNameOrCode) || _.isEmpty(additionalModule)) {
                return $q.when({});
            }

            // FIXME: We should ALWAYS also add the service-name!
            var memoKey = [additionalCategoryNameOrCode, additionalModule].join(':');
            if (_this.memo[memoKey]) {
                return $q.when(_this.memo[memoKey]());
            }

            if (_this.statusMap[memoKey] === "pending") {
                return new Promise(function(_res, _rej) {
                    _this.pendingResolvers[memoKey].push({ resolve: _res, reject: _rej });
                });
            }

            var deferred = $q.defer();
            try {
                _this.statusMap[memoKey] = "pending";
                _this.pendingResolvers[memoKey] = [];

                var currentDataModelHash = $rootScope.organization.dataModelHash;
                var currentLanguage = $rootScope.language || 'en';

                $rootScope.dataModel
                    .getCachedAdditionalCategory(additionalCategoryNameOrCode, additionalModule, currentDataModelHash, currentLanguage)
                    .then(function(result) {

                        if (_.isEmpty(result) || result.dataModelHash !== currentDataModelHash || result.translatedLanguage !== $rootScope.language) {

                            // Also ensure the cache is busted when the data model hash is different (if exists)
                            $rootScope.dataModel
                                    .deleteCachedAdditionalCategory(additionalCategoryNameOrCode, additionalModule)
                                    .then(function() {

                                        _this.fetchAndCacheAdditionalCategory(additionalCategoryNameOrCode, additionalService, additionalModule)
                                            .then(function(result) {
                                                result.translatedLanguage = $rootScope.language;
                                                _this._settle(memoKey, result);
                                                deferred.resolve(result);

                                            });

                                    });
                        } else {

                            _this._settle(memoKey, result);
                            deferred.resolve(result);
                        }
                    });

            } catch (err) {
                $log.error('AdditionalCategoryService: Could not load additional category entry', memoKey, err);
                _this.statusMap[memoKey] = "error";
                var waiters = _this.pendingResolvers[memoKey] || [];
                delete _this.pendingResolvers[memoKey];
                waiters.forEach(function(waiter) {
                    waiter.reject(err);
                });
                throw err;
            }

            return deferred.promise;
        };

        this._settle = function(memoKey, result) {
            _this.statusMap[memoKey] = "success";
            _this.memo[memoKey] = function get() {
                return result;
            };
            var waiters = _this.pendingResolvers[memoKey] || [];
            delete _this.pendingResolvers[memoKey];
            waiters.forEach(function(waiter) {
                waiter.resolve(result);
            });
        };

        this.fetchAndCacheAdditionalCategory = function(additionalCategoryNameOrCode, additionalService, additionalModule) {

            return DataModelResource().getCategory({
                nameOrCode: additionalCategoryNameOrCode,
                serviceName: additionalService,
                dataModel: additionalModule
            }).$promise.then(function(result) {

                result.additionalCategoryNameOrCode = additionalCategoryNameOrCode;
                result.additionalModule = additionalModule;

                var currentDataModelHash = $rootScope.organization.dataModelHash;
                var currentLanguage = $rootScope.language || 'en';
                result.dataModelHash = currentDataModelHash;

                $rootScope.dataModel.insertCachedAdditionalCategory(additionalCategoryNameOrCode, additionalModule, currentDataModelHash, currentLanguage, result);
                return result;

            });
        };
    });
